import React, { useEffect, useState } from 'react';
import { TableDefaultSticky } from '../../../../shared/components/table/TableDefaultSticky';
import { TableColumnType } from '../../../../shared/components/table/table-types';
import { useStore } from '@cobuildlab/react-simple-state';
import { changeDashboardDateFilterStore } from '../../dashboard-events';
import { Box, Card, CardContent } from '@mui/material';
import { subscriptionStatus } from '../../dashboard-utils';
import { useStylesCustom } from '../DashboardCardItem';
import {
  Subscription,
  useSubscriptionCancelledByFilterLazyQuery,
} from '../../../../shared/types/generated';
import { SubscriptionUserModal } from './SubscriptionUserModal';
import { GlobalSubscriptionTable } from '../../../subscription/subscription-types';
import {getDateByTimezone} from "../../../../shared/utils";

export const DashboardSubscriptionsCancelledTable: React.FC = () => {
  const classes = useStylesCustom();
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState<Subscription[]>([]);
  const [total, setTotal] = useState(0);
  const [currentUserSubscription, setCurrentUserSubscription] = useState<GlobalSubscriptionTable>();
  const { from, to } = useStore(changeDashboardDateFilterStore);

  const [callSubscription, { loading }] = useSubscriptionCancelledByFilterLazyQuery({
    onCompleted: (event) => {
      setData(event.subscriptionCancelledByFilter?.items || []);
      setTotal(event.subscriptionCancelledByFilter?.total || 0);
    },
  });

  const [pagination, setPagination] = useState({
    pageSize: 10,
    page: 1,
  });

  useEffect(() => {
    callSubscription({
      variables: {
        where: {
          from,
          to,
          page: pagination.page,
          pageSize: pagination.pageSize,
        },
      },
    });
  }, [from, to, pagination, callSubscription]);

  const handleOpenModal = (item: Subscription): void => {
    console.log('item', item);
    setCurrentUserSubscription({
      id: item.id?.toString() || '',
      planId: item.plan?.id,
      status: item.status,
      customer_id: item.customer_id,
      period_end_date: getDateByTimezone(item.period_end_date),
      period_start_date: getDateByTimezone(Number(item.period_start_date)),
      date: item.created_at,
      created_at: getDateByTimezone(Number(item.created_at)),
      updated_at: item.updated_at,
      user_id: item.user?.id,
      payment_method: item.payment_method,
      type: item.type,
      transaction_id: item.transaction_id,
      cancel_date: getDateByTimezone(Number(item.cancel_date)),
      is_cancel: item.is_cancel ? 1 : 0,
      user_name: item.user?.name,
      user_email: item.user?.email,
      user_status: item.user?.user_status,
      plan_title: item.plan?.title,
      plan_price: item.plan?.price || 0,
      plan_frequency: item.plan?.frequency,
    } as GlobalSubscriptionTable);
    setOpenModal(true);
  };

  const COLUMNS: TableColumnType<Subscription>[] = [
    {
      columnName: 'FECHA DE CANCELACIÓN',
      columnValue: null,
      columnComponent: (item) => (
        <Box style={{ whiteSpace: 'nowrap' }}>
          {getDateByTimezone(item.cancel_date)}
        </Box>
      ),
    },
    {
      columnName: 'NOMBRE',
      columnValue: null,
      columnComponent: (item) => (
        <Box style={{ whiteSpace: 'nowrap' }}>{item?.user?.name || 'N/A'}</Box>
      ),
    },
    {
      columnName: 'EMAIL',
      columnValue: (item) => item?.user?.email || 'N/A',
    },
    {
      columnName: 'PLAN',
      columnValue: (item) => (item?.plan?.title as string) || 'N/A',
    },
    {
      columnName: 'N° DE TRANSACCIÓN',
      columnValue: (item) => item?.transaction_id || '',
    },
    {
      columnName: 'TIPO DE PAGO',
      columnValue: (item) => (item.type === 'PAYMENT' ? 'Primer pago' : 'Pago recurrente'),
    },
    {
      columnName: 'MÉTODO DE PAGO',
      columnValue: (item) => item?.payment_method || '',
    },
    {
      columnName: 'STATUS',
      columnValue: (item) => subscriptionStatus(item.status || ''),
    },
  ];

  return (
    <>
      <SubscriptionUserModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        userSubscription={currentUserSubscription}
      />
      <Card
        elevation={2}
        style={{
          border: '1px solid #BBBBBB',
          padding: '16px',
          borderRadius: '16px',
          boxShadow: '0px 0px 8px 0px #00000014',
        }}
      >
        <CardContent className={classes.content}>
          <TableDefaultSticky
            count={total}
            items={data}
            columns={COLUMNS}
            page={pagination.page}
            pageSize={pagination.pageSize}
            loading={loading}
            messageLoading={'Cargando suscripciones canceladas...'}
            handleClickRow={(item) => handleOpenModal(item)}
            handleChangePage={(page) => {
              setPagination({
                ...pagination,
                page: page + 1,
              });
            }}
          />
        </CardContent>
      </Card>
    </>
  );
};
